<template>
  <div class="border px-1" style="display: flex; justify-content: space-between">
    <div style="width: 100%">
      <input :value="value" @input="$emit('input', $event.target.value)" @keydown.enter="$emit('down')" ref="input" />
    </div>
    <div style="display: flex; align-items: center">
      <label class="mx-2">{{ text }}</label>
      <span class="delimiter mr-1"></span>
      <v-btn class="mx-0" icon small @click="$emit('up')">
        <v-icon small>mdi-chevron-up</v-icon>
      </v-btn>
      <v-btn class="mx-0" icon small @click="$emit('down')">
        <v-icon small>mdi-chevron-down</v-icon>
      </v-btn>
      <v-btn class="mx-0" icon small @click="$emit('close')">
        <v-icon small>mdi-close</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'text'],
  mounted() {
    this.$nextTick(() => this.$nextTick(() => this.$refs.input.focus()));
  },
}
</script>

<style scoped>
.border {
  border-bottom-color: rgb(199, 207, 211);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
  border-image-outset: 0;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  border-left-color: rgb(199, 207, 211);
  border-left-style: solid;
  border-left-width: 1px;
  border-right-color: rgb(199, 207, 211);
  border-right-style: solid;
  border-right-width: 1px;
  border-top-color: rgb(199, 207, 211);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-top-style: solid;
  border-top-width: 1px;
}

input,
label {
  font-size: 16px;
}
input {
  width: 100%;
  height: 100%;
}
input:focus {
  outline: none;
}

.delimiter {
  height: 28px;
  background-color: black;
  display: inline-block;
  width: 1px;
}
</style>